// extracted by mini-css-extract-plugin
export default {"flex":"InquiryNumber_flex__i4mvK","title":"InquiryNumber_title__+K3Y-","input_text":"InquiryNumber_input_text__F5l0s"};